import React from 'react'
import "./InquiryAdmin.css"
import Sidebar from '../StudentSideBar/StudentSidebar'
import StudentNavbar from '../StudentNavbar/StudentNavbar'
import BLOCKCHAIN from "../../Image/BC 1.png"
import Mern from "../../Image/MERN (1) 1.png"
import PYTHON from "../../Image/PYTHON 1.png"
import UI from "../../Image/UIUX 1.png"
import Data from "../../Image/DS (1) 1.png"
import React1 from "../../Image/react 1.png"

function InquiryAdmin() {



    const courses = [
        {
          icon: BLOCKCHAIN,
          title: "BLOCKCHAIN",
          description:
            "A decentralized digital ledger technology for secure and transparent transactions.",
        },
        {    
          icon: Mern,
          title: "MERN",
          description:
            "MERN: MongoDB, Express.js, React, Node.js – Full-stack JavaScript framework.",
        },
        {
          icon: React1,
          title: "REACT",
          description:
            "React is a JavaScript library for building user interfaces efficiently.",
        },
        {
          icon: PYTHON,
          title: "PYTHON",
          description:
            "Python is a powerful, versatile programming language for many applications.",
        },
        {
          icon: UI,
          title: "UIUX",
          description:
            "Enhancing user satisfaction through effective, intuitive interface design.",
        },
        {
          icon: Data,
          title: "DATA SCIENCE",
          description:
            "Analyzing data to extract insights and make decisions.",
        },
      ];


  return (
    <>
      <div className='inquiryAdmin'>
        <div>
            <Sidebar/>
        </div>
        <div className='inquiry-Nav'>
            <StudentNavbar/>
            <div>
            <div className="inquiry-wrapper">
      <h2 className="inquiry-heading">All Courses</h2>
      <div className="inquiry-grid">
        {courses.map((course, index) => (
          <div className="inquiry-card" key={index}>
            <div className="inquiry-banner">
              <img src={course.icon} alt={course.title} className="inquiry-icon" />
            </div>
            <h3 className="inquiry-title">{course.title}</h3>
            <p className="inquiry-desc">{course.description}</p>
            <button className="inquiry-button">Learn More</button>
          </div>
        ))}
      </div>
    </div>
            </div>
        </div>
      </div>
    </>
  )
}

export default InquiryAdmin
